<div class="custom-ag-header" [ngClass]="{'sort-enabled': params.enableSorting}">
  <!-- Single button for the whole header: label + sort indicator in one control.
       Previously there were 3 buttons per header (label + ascending + descending),
       causing Dragon to assign 3 numbers to the same visual control.
       The sort icon is decorative (aria-hidden) — sort state is communicated via
       aria-sort on the AG Grid header cell (set in updateAriaSort()).
       The text is wrapped in .header-text so overflow:hidden/ellipsis only clip
       the text, not the sort icon (which was hidden on narrow columns before). -->
    <!-- Only sortable columns render an interactive button. Non-sortable labels
      remain plain spans: hidden headers such as Select are skipped, while a
      visible named header such as Actions can make its columnheader wrapper a
      static Tab stop without falsely presenting the label as a button. -->
  <button *ngIf="params.enableSorting; else nonSortableLabel"
      type="button" class="customHeaderLabel" placement="top" [pTooltip]="params.displayName" tooltipPosition="right"
      [tooltipEvent]="params.showTooltipOnFocus === false ? 'hover' : 'both'"
       [attr.aria-label]="params.displayName | translate"
       (click)="toggleSortOrder($event)" (touchstart)="toggleSortOrder($event)">
    <span class="header-text">{{ params.displayName | translate}}</span>
    <span class="sort-icon-wrapper" aria-hidden="true">
      <esp-icon [ngClass]="getSortOrderStatus('asc')" class="customSortDownLabel" name="arrow-up-narrow-wide"></esp-icon>
      <esp-icon [ngClass]="getSortOrderStatus('desc')" class="customSortUpLabel" name="arrow-down-wide-narrow"></esp-icon>
    </span>
  </button>
  <!-- Opt-in only (params.showHeaderTooltip): most non-sortable headers
       (Select, Actions) stay tooltip-free as before - the pTooltip directive
       is only present in the DOM (and so only bridges focus/blur, see
       ngAfterViewInit) when a grid explicitly asks for the same PrimeNG
       tooltip its sortable headers use, e.g. Historical Data's date columns
       via headerComponentParams.showHeaderTooltip. -->
  <ng-template #nonSortableLabel>
    <span class="customHeaderLabel" *ngIf="!params.showHeaderTooltip; else nonSortableLabelWithTooltip">
      <span class="header-text">{{ params.displayName | translate}}</span>
    </span>
  </ng-template>
  <ng-template #nonSortableLabelWithTooltip>
    <!-- The tooltip is bound to .header-text (sized to the text itself), not
         the outer full-width .customHeaderLabel span: a narrow, left-aligned
         label (e.g. a short date) leaves a lot of empty column space to its
         right, and PrimeNG's "right" position anchors off the ELEMENT it is
         bound to. Binding the outer span placed the tooltip off in that empty
         space instead of next to the visible text. -->
    <span class="customHeaderLabel">
      <span class="header-text"
          [pTooltip]="params.displayName" tooltipPosition="right"
          [tooltipEvent]="params.showTooltipOnFocus === false ? 'hover' : 'both'">{{ params.displayName | translate}}</span>
    </span>
  </ng-template>
</div>
